import React, { Component } from "react";
import { s360ConfigService } from "../../Services/S360Config";
import dayjs from "dayjs";

class MessageA14 extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
    }

    render() {
        return (
            <div className="s360-message-cotainer-received">
                <div className="s360-message-box-custom-a14-received" style={this.messageBoxStyle()}>
                    <input type="text" ref={this.messageRef} className="s360-message-box-custom-a14-textbox-input" onClick={this.onClickInput} onKeyPress={this.onInputKeyPress} onBlur={this.onInputOut} style={this.formInputBoxStyle()} />
                </div>
                {this.props.isLastEntry && this.props.sentTimestamp && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.sentTimestamp).format("h:mm a")}</div>}
            </div>
        );
    }

    messageBoxStyle = () => {
        return { background: s360ConfigService.config.designDetails.senderMessageColor, fontFamily: s360ConfigService.config.designDetails.SenderMessageFont, fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize, color: s360ConfigService.config.designDetails.senderMessageFontColor }
    }

    formInputBoxStyle = () => {
        return { borderColor: s360ConfigService.config.designDetails.headerColor, color: s360ConfigService.config.designDetails.headerColor, backgroundColor: s360ConfigService.config.designDetails.pageBackgroundColor }
    }

    onInputKeyPress = (e) => {
        if(e.key === 'Enter') {
            this.messageRef && this.messageRef.current && this.messageRef.current.blur();
        }
    }

    onInputOut = () => {
        let value = this.messageRef && this.messageRef.current && this.messageRef.current.value && this.messageRef.current.value.trim();
        if (value) {
            this.props.actions.sendMessage(value);
        }
    }

}

export default MessageA14;